module.exports = __webpack_public_path__ + "assets/img/Favorites-Playlist-Banner.31abed59.jpg";